import dayjs from 'dayjs';
import * as yup from 'yup';

export const validationSchema = yup.object<CompraFormValues>({
  folioInterno: yup.string().required('El folio interno es requerido'),
  fecha: yup.mixed<dayjs.Dayjs>().required('La fecha es requerida'),
  referencia: yup.string(),
  idPersonaVende: yup.number().moreThan(0, '"Vendido Por" es requerido'),
  vendidoPor: yup.string(),
  idPersonaRecibe: yup.number().moreThan(0, '"Recibido Por" es requerido'),
  recibidoPor: yup.string(),
  idPersonaEntrega: yup.number().moreThan(0, '"Entregado Por" es requerido'),
  entregadoPor: yup.string(),
  idCorral: yup.number().moreThan(0, '"Corral de Reciba" es requerido'),
  animales: yup
    .array()
    .of(
      yup.object<AnimalCompra>({
        precio: yup.number().moreThan(0, 'El precio es requerido'),
      })
    )
    .test({
      name: 'total',
      message: 'La cantidad de animales capturados debe ser igual al total de animales indicado',
      test: (values: any[] | undefined, context) => {
        const numAnimales = context.parent.totalAnimales;
        const capturados = values?.length ?? 0;
        return capturados === numAnimales;
      }
    })
});

export interface CompraFormValues {
  folioInterno: string;
  fecha: dayjs.Dayjs;
  referencia: string;
  idPersonaVende: number;
  vendidoPor: string;
  idPersonaRecibe: number;
  recibidoPor: string;
  idPersonaEntrega: number;
  entregadoPor: string;
  idCorral: number;
  totalAnimales: number;
  animales: Array<AnimalCompra>;
}

export interface AnimalCompra {
  id: string;
  partida: number;
  areteSiiniga: string;
  areteTemporal: string;
  tienePapeles: boolean;
  reemo: string;
  idTipoGanado: number;
  tipoGanado: string;
  kgCompra: number;
  kgLlegada: number;
  descuentoPeso: number;
  kgNetos: number;
  precio: number;
  importe: number;
}
